import { useState } from 'react';
import type { PreisToolItem, PreisToolSupplierAnomaly } from '@/api/preis-tool/preis-tool.types';
import { DsButton } from '@/modules/internal-v2/ds';
import { fmtEUR, fmtLimitPct } from '../helpers';

interface RightRailProps {
  anomalies: PreisToolSupplierAnomaly[];
  isLoading: boolean;
  minSavingsPct: number;
  setSelectedId: (id: string) => void;
  basket: string[];
  setBasket: (ids: string[]) => void;
  articles: PreisToolItem[];
}

export function RightRail({
  anomalies,
  isLoading,
  minSavingsPct,
  setSelectedId,
  basket,
  setBasket,
  articles,
}: RightRailProps) {
  const [anomaliesOpen, setAnomaliesOpen] = useState(true);
  const [basketOpen, setBasketOpen] = useState(true);

  return (
    <div className="pt-rail">
      <div className={`pt-rail-section${anomaliesOpen ? ' flex' : ''}`}>
        <div className="pt-rail-header" onClick={() => setAnomaliesOpen(!anomaliesOpen)} style={{ cursor: 'pointer' }}>
          <h3>
            <span className="pt-rail-chevron">{anomaliesOpen ? '▾' : '▸'}</span>
            Auffälligkeiten
            <span className="pt-rail-sub" title="Grenze „Deal“ der Farblegende">Lief. u. MEK · ≥ {fmtLimitPct(minSavingsPct)}</span>
          </h3>
          <span className="cnt">{anomalies.length}</span>
        </div>
        {anomaliesOpen && (
          <div className="pt-rail-body ds-scroll">
            {isLoading && <div className="pt-anomaly-empty">Lade…</div>}
            {!isLoading && anomalies.length === 0 && (
              <div className="pt-anomaly-empty">Keine Auffälligkeiten</div>
            )}
            {anomalies.map((x) => (
              <div key={x.offerId} className="pt-anomaly-item" onClick={() => setSelectedId(x.itemId)}>
                <div className="a-top">
                  <span className="a-id">{x.itemId}</span>
                  <span className="ds-pill pos">−{(x.savingsPct * 100).toFixed(1)}%</span>
                </div>
                <div className="a-name">{x.itemName}</div>
                <div className="a-reason">
                  <span className="a-supplier">{x.supplierName}</span>
                  <span className="a-sep">·</span>
                  <span className="a-feed">{x.feedName ?? 'Fixpreis'}</span>
                  <span className="a-sep">·</span>
                  <span className="a-price">
                    {fmtEUR(x.netPrice)} {x.currency}
                    <span className="a-vs"> vs MEK {fmtEUR(x.movingAveragePrice)}</span>
                  </span>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
      <div className="pt-rail-section">
        <div className="pt-rail-header" onClick={() => setBasketOpen(!basketOpen)} style={{ cursor: 'pointer' }}>
          <h3>
            <span className="pt-rail-chevron">{basketOpen ? '▾' : '▸'}</span>
            Bulk-Basket
          </h3>
          <span className="cnt">{basket.length}</span>
        </div>
        {basketOpen && (
          <>
            <div className="ds-scroll" style={{ maxHeight: 140, overflow: 'auto' }}>
              {basket.length === 0 && (
                <div className="pt-basket-empty">
                  Leer · Zeilen mit <span className="ds-kbd">B</span> hinzufügen
                </div>
              )}
              {basket.map((id) => {
                const a = articles.find((x) => x.id === id);
                if (!a) return null;
                return (
                  <div key={id} className="pt-basket-item">
                    <span className="b-id" title={a.name}>{a.id}</span>
                    <span className="x" onClick={() => setBasket(basket.filter((b) => b !== id))}>×</span>
                  </div>
                );
              })}
            </div>
            {basket.length > 0 && (
              <div style={{ padding: '8px 12px', borderTop: '1px solid var(--border)', display: 'flex', gap: 6 }}>
                <DsButton style={{ flex: 1 }}>Marge setzen…</DsButton>
                <DsButton variant="primary" style={{ flex: 1 }}>Bulk-PATCH</DsButton>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
}
